import { connect } from 'react-redux'
import { bindActionCreators, Dispatch } from 'redux'

import { State } from 'redux/rootReducer'
import { SettingsPersonalInfoEmail } from 'App/components'
import { showModalAction } from 'store'

export type TSettingsPersonalInfoEmailContainerProps = ReturnType<typeof mapStateToProps> &
  ReturnType<typeof mapDispatchToProps>

const mapStateToProps = (state: State) => ({
  email: state.global.accountData?.email
})

const mapDispatchToProps = (dispatch: Dispatch) =>
  bindActionCreators({ showModal: showModalAction }, dispatch)

export const SettingsPersonalInfoEmailContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(SettingsPersonalInfoEmail)
